export default __webpack_public_path__ + "static/media/2.ac45235f.jpg";